import { observer } from 'mobx-react'
import { Button, Col, Row, Typography, Tooltip, Space } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons'
import { Copy } from './Copy'
import { useChilizStore } from '../stores'
import { truncateAddress } from '../utils/truncateAddress'
import { AccountImage } from './AccountImage'

const { Text } = Typography

interface IConnectionIndicator {
  onClick?: (...args: any) => any
}

export const ConnectionIndicator = observer(({ onClick }: IConnectionIndicator) => {
  const store = useChilizStore()
  const currentAccount = store.getKeyProvider().currentAccount()
  const truncatedAddress = truncateAddress(currentAccount)
  const tooltipText = <Space>{currentAccount}<Copy text={currentAccount}/></Space>
  return (
    <Button shape="round" type="text" size="large" className="connection-indicator" onClick={onClick}>
      <Row>
        <Space>
          <Col>
            <AccountImage account={currentAccount} showMetamaskLogo={false} size={30}/>
          </Col>
          <Col>
            <Row>
              <Tooltip title={tooltipText}>
                <Text strong style={{ fontSize: '1.1em' }}>{truncatedAddress}</Text>
              </Tooltip>
            </Row>
          </Col>
        </Space>
      </Row>
    </Button>
  )
})
